import { signalVariants, type SignalVariantTypes } from '@etg/wings';
import { CancellationRefundOfferReason } from '@eti/schema-types';
import type { Unit } from 'humanize-duration';
import type { CancellationOptionInfoType } from '../models';

type ExpirationBadgeFormatType = {
  badgeVariant: SignalVariantTypes;
  units: Unit[];
};

export const getExpirationFormat = (
  expiresInSec: number,
  displayMinutesNextToHours: boolean,
): ExpirationBadgeFormatType => {
  const ONE_MINUTE = 60;
  const ONE_HOUR = 60 * ONE_MINUTE;
  const ONE_DAY = 24 * ONE_HOUR;

  if (expiresInSec < ONE_HOUR) {
    return {
      badgeVariant: signalVariants.CRITICAL,
      units: ['m'],
    };
  }
  if (expiresInSec < ONE_DAY) {
    return {
      badgeVariant: signalVariants.CAUTION,
      units: displayMinutesNextToHours ? ['h', 'm'] : ['h'],
    };
  }
  return {
    badgeVariant: signalVariants.INFORMATION,
    units: ['d'],
  };
};

export const getSortedCancellationOptions = (
  cancellationOptionsList: CancellationOptionInfoType[],
) => {
  const orderOfCancellationReasons = [
    CancellationRefundOfferReason.Void,
    CancellationRefundOfferReason.CancelForAnyReason,
    CancellationRefundOfferReason.TicketRules,
    'CANCELLATION_INSURANCE_COVER_GENIUS',
    'CANCELLATION_GUARANTEE_EXTRA',
    'INSURANCE_EU',
    'INSURANCE_NON_EU',
  ];

  return cancellationOptionsList
    ? cancellationOptionsList.sort((optionA, optionB) => {
        const isOptionAExpired = Number(optionA.refundOffer?.expirationTimeInSec === 0);
        const isOptionBExpired = Number(optionB.refundOffer?.expirationTimeInSec === 0);
        if (isOptionAExpired || isOptionBExpired) {
          return isOptionAExpired - isOptionBExpired;
        }

        const indexA = orderOfCancellationReasons.indexOf(optionA.reason);
        const indexB = orderOfCancellationReasons.indexOf(optionB.reason);

        // If a or b is not in the order array, move them to the end
        const rankA = indexA === -1 ? Infinity : indexA;
        const rankB = indexB === -1 ? Infinity : indexB;

        return rankA - rankB;
      })
    : [];
};
